"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContractManagerEventType = void 0;
var ContractManagerEventType;
(function (ContractManagerEventType) {
    ContractManagerEventType["VestingDeployed"] = "VestingDeployed";
    ContractManagerEventType["ERC20TokenDeployed"] = "ERC20TokenDeployed";
    ContractManagerEventType["ERC721TokenDeployed"] = "ERC721TokenDeployed";
    ContractManagerEventType["ERC998TokenDeployed"] = "ERC998TokenDeployed";
    ContractManagerEventType["ERC1155TokenDeployed"] = "ERC1155TokenDeployed";
    ContractManagerEventType["MysteryBoxDeployed"] = "MysteryBoxDeployed";
    ContractManagerEventType["LootBoxDeployed"] = "LootBoxDeployed";
    ContractManagerEventType["CollectionDeployed"] = "CollectionDeployed";
    ContractManagerEventType["PaymentSplitterDeployed"] = "PaymentSplitterDeployed";
    ContractManagerEventType["PonziDeployed"] = "PonziDeployed";
    ContractManagerEventType["StakingDeployed"] = "StakingDeployed";
    ContractManagerEventType["LotteryDeployed"] = "LotteryDeployed";
    ContractManagerEventType["RaffleDeployed"] = "RaffleDeployed";
    ContractManagerEventType["WaitListDeployed"] = "WaitListDeployed";
})(ContractManagerEventType || (exports.ContractManagerEventType = ContractManagerEventType = {}));
//# sourceMappingURL=contract-manager.js.map